// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretDown: React.FC<{ width?: number; height?: number }> = ({ width = 9, height = 5 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 5">
            <path
                fill="currentColor"
                d="M.758 0a.767.767 0 0 0-.702.446c-.117.268-.046.558.164.782l3.742 3.571a.82.82 0 0 0 1.076 0L8.78 1.228c.21-.224.28-.514.164-.782A.767.767 0 0 0 8.242 0H.758Z"
            />
        </svg>
    );
};

export default React.memo(CaretDown);
